import { AxiosError } from 'axios'
import { action, flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers'

import { UrlParams } from 'Portals/Customer/constants'
import { Wastestream } from 'Portals/Customer/entities'
import {
	filtersConfig,
	searchConfig
} from 'Portals/Customer/Pages/Wastestream/TableList/Filters/utils/config'
import { WastestreamRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

const STORAGE_WASTESTREAM_PAGE_SIZE = storagePageSizeConstant('wastestream')

export class WastestreamTable extends TableStore<Wastestream.Basic> {
	constructor(public rootStore: RootStore) {
		super(STORAGE_WASTESTREAM_PAGE_SIZE)
		makeObservable(this)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				repository: WastestreamRepo.getList,
				defaultSort
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	@action.bound
	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [UrlParams.id, UrlParams.name, CoreUrlParams.searchQuery]
		const filterKeys = [UrlParams.serviceSiteId]

		const mergedSearchConfig = {
			...searchConfig,
			...searchQueryConfig
		}
		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, filtersConfig)
	}

	reset = () => {
		this.resetTable()
	}
}
